import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGift = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.833 6.963c.427-.486.595-1.153.447-1.783l-.055-.229a2 2 0 0 0-1.665-1.477l-1.663-.183a2.3 2.3 0 0 0 .02-.303c0-1.264-1.028-2.292-2.292-2.292-.635 0-1.209.259-1.625.677C7.584.955 7.009.695 6.374.695c-1.264 0-2.292 1.028-2.292 2.292 0 .103.007.205.021.305l-1.665.185A2 2 0 0 0 .774 4.955l-.055.228c-.147.631.021 1.298.448 1.784.084.096.175.182.273.258-.405 2.048-.331 4.389.201 6.298a2 2 0 0 0 1.632 1.437 32.48 32.48 0 0 0 4.726.345 32.57 32.57 0 0 0 4.727-.345c.779-.115 1.42-.679 1.631-1.437.533-1.91.605-4.251.201-6.301.097-.076.189-.163.273-.259h.002zm-1.447-2.167c.263.035.482.229.547.486l.049.199a.67.67 0 0 1-.151.602.64.64 0 0 1-.561.221l-4.603-.255v-1.59a40.95 40.95 0 0 1 4.719.338l.001-.001zm-3.76-2.766a.96.96 0 0 1 .959.959l-.01.206-1.895-.069-.011-.137a.96.96 0 0 1 .959-.959h-.001zm-3.25 0a.96.96 0 0 1 .959.959c0 .037-.006.093-.011.138l-1.895.07a1.6 1.6 0 0 1-.01-.208.96.96 0 0 1 .959-.959h-.001zM2.018 5.485l.049-.203c.065-.254.284-.449.546-.483 1.525-.202 3.119-.316 4.72-.341v1.59l-4.604.259a.64.64 0 0 1-.561-.221.67.67 0 0 1-.151-.601zm.908 7.679c-.458-1.643-.533-3.729-.207-5.523l.145-.009 4.47-.252v6.583a31.22 31.22 0 0 1-3.866-.324.66.66 0 0 1-.541-.477l-.001.001zm10.148 0a.67.67 0 0 1-.541.477 31.21 31.21 0 0 1-3.866.324V7.381l4.47.249.144.009c.327 1.795.252 3.883-.206 5.525l-.001.001z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgGift;
